import modularScale from 'styles/helpers/modular-scale';
import colors from 'styles/themes/colors';

const variables = {
  topbarHeight: '3em',
  layout: {
    smallScreen: 0.9,
    largeScreen: 0.75,
  },
  breakpoints: ['30em', '50em', '80em'],
  space: [
    '0',
    '0.25rem',
    '0.5rem',
    '0.75rem',
    '1rem',
    '1.5rem',
    '2.5rem',
    '3.5rem',
    '5rem',
    '8rem',
    '10rem',
  ],
  colors,
  fonts: {
    body: `'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, Helvetica, Arial, sans-serif`,
    numbers: `'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Roboto, Helvetica, Arial, sans-serif`,
  },
  spacing: {
    xxsmall: modularScale(-8),
    xsmall: modularScale(-4),
    small: modularScale(-3),
    medium: modularScale(0),
    large: modularScale(2),
    xlarge: modularScale(4),
    xxlarge: modularScale(6),
    huge: modularScale(8),
    enormous: modularScale(10),
  },
  transitionDuration: '150ms',
  timingFunction: 'cubic-bezier(0.5, 0 , 0.5, 1)',
  numbersTypography: `'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI',
  Roboto, Helvetica, Arial, sans-serif`,
  primaryTypography: `'Proxima Nova', -apple-system, BlinkMacSystemFont, 'Segoe UI',
  Roboto, Helvetica, Arial, sans-serif`,
  /** The width / height ratio of the Artwork is 83 / 70  */
  groupArtworkRatio: 83 / 70,
};

variables.colors.greys = [
  // sorted by lightness, darkest = 0
  '#282D38',
  '#616161',
  '#a6a6a6',
  '#ccc',
  '#E6E6E6',
  '#f4f4f4',
  '#f9f9f9',
];

variables.colors.grays = colors.greys;

export default variables;
